function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  id: "surface1"
}, /*#__PURE__*/React.createElement("path", {
  d: "M 11 1 C 11 0.449219 11.449219 0 12 0 C 12.550781 0 13 0.449219 13 1 L 13 3 C 13 3.550781 12.550781 4 12 4 C 11.449219 4 11 3.550781 11 3 Z M 11 1 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 18 12 C 18 15.3125 15.3125 18 12 18 C 8.6875 18 6 15.3125 6 12 C 6 8.6875 8.6875 6 12 6 C 15.3125 6 18 8.6875 18 12 Z M 8.0625 12 C 8.0625 14.175781 9.824219 15.9375 12 15.9375 C 14.175781 15.9375 15.9375 14.175781 15.9375 12 C 15.9375 9.824219 14.175781 8.0625 12 8.0625 C 9.824219 8.0625 8.0625 9.824219 8.0625 12 Z M 8.0625 12 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 20.484375 3.515625 C 20.09375 3.125 19.460938 3.125 19.070312 3.515625 L 17.65625 4.929688 C 17.265625 5.320312 17.265625 5.953125 17.65625 6.34375 C 18.046875 6.734375 18.679688 6.734375 19.070312 6.34375 L 20.484375 4.929688 C 20.875 4.539062 20.875 3.90625 20.484375 3.515625 Z M 20.484375 3.515625 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 1 13 C 0.449219 13 0 12.550781 0 12 C 0 11.449219 0.449219 11 1 11 L 3 11 C 3.550781 11 4 11.449219 4 12 C 4 12.550781 3.550781 13 3 13 Z M 1 13 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 3.515625 3.515625 C 3.125 3.90625 3.125 4.539062 3.515625 4.929688 L 4.929688 6.34375 C 5.320312 6.734375 5.953125 6.734375 6.34375 6.34375 C 6.734375 5.953125 6.734375 5.320312 6.34375 4.929688 L 4.929688 3.515625 C 4.539062 3.125 3.90625 3.125 3.515625 3.515625 Z M 3.515625 3.515625 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 11 21 C 11 20.449219 11.449219 20 12 20 C 12.550781 20 13 20.449219 13 21 L 13 23 C 13 23.550781 12.550781 24 12 24 C 11.449219 24 11 23.550781 11 23 Z M 11 21 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 6.34375 17.65625 C 5.953125 17.265625 5.320312 17.265625 4.929688 17.65625 L 3.515625 19.070312 C 3.125 19.460938 3.125 20.09375 3.515625 20.484375 C 3.90625 20.875 4.539062 20.875 4.929688 20.484375 L 6.34375 19.070312 C 6.734375 18.679688 6.734375 18.046875 6.34375 17.65625 Z M 6.34375 17.65625 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 21 13 C 20.449219 13 20 12.550781 20 12 C 20 11.449219 20.449219 11 21 11 L 23 11 C 23.550781 11 24 11.449219 24 12 C 24 12.550781 23.550781 13 23 13 Z M 21 13 "
}), /*#__PURE__*/React.createElement("path", {
  d: "M 17.65625 17.65625 C 17.265625 18.046875 17.265625 18.679688 17.65625 19.070312 L 19.070312 20.484375 C 19.460938 20.875 20.09375 20.875 20.484375 20.484375 C 20.875 20.09375 20.875 19.460938 20.484375 19.070312 L 19.070312 17.65625 C 18.679688 17.265625 18.046875 17.265625 17.65625 17.65625 Z M 17.65625 17.65625 "
}));

const SvgSun = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "24px",
  height: "24px",
  viewBox: "0 0 24 24",
  style: {
    fill: "inherit"
  },
  ref: svgRef
}, props), _ref);

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgSun, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sun.c22e47ba.svg";
export { ForwardRef as ReactComponent };